"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useAcdcPopupProps_1 = __importDefault(require("./useAcdcPopupProps"));
var renderPropType_1 = __importDefault(require("./utils/renderPropType"));
var AcdcPopup = function (_a) {
    var children = _a.children;
    var _b = __read(useAcdcPopupProps_1.default(), 1), popupProps = _b[0];
    return react_1.default.createElement(react_1.default.Fragment, null, children(popupProps));
};
if (process.env.NODE_ENV !== 'production') {
    AcdcPopup.propTypes = {
        children: renderPropType_1.default([]),
    };
}
exports.default = AcdcPopup;
